export default __webpack_public_path__ + "static/media/icn-inverted-female.8ef0c1f5.svg";